import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { routeNames } from "../../../routes/routeNames";
import withAnimation from "../../../hooks/withAnimation";

const WellnessSection = () => {
  return (
    <section
      className="relative bg-cover bg-center py-10 lg:py-20 text-center text-white"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1581090124355-6c1376cf3047')",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Black Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-70"></div>

      {/* Content Container */}
      <div className="relative flex flex-col justify-center items-center self-center max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-justify">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
          Our Comprehensive Approach to Health and Wellness
        </h1>
        <p className="mt-6 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
          At Conklin Chiropractic, we are committed to empowering our patients
          with the tools and support they need to live a pain-free and active
          life. Our comprehensive approach to health and wellness leverages the
          latest techniques and technologies to deliver customized solutions
          that address each individual’s unique needs.
        </p>
        <p className="mt-4 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
          We understand that everyone's journey to optimal health is different,
          and that’s why we work closely with our patients to create customized
          care plans that are tailored to their specific goals and needs.
          Whether you're looking to manage pain, improve mobility and function,
          or perform better in your favorite activities, our team of experienced
          therapists will be there every step of the way to support you in
          achieving your desired outcomes.
        </p>
        <p className="mt-4 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
          We understand that everyone's journey to optimal health is different,
          and that’s why we work closely with our patients to create customized
          care plans that are tailored to their specific goals and needs.
          Whether you're looking to manage pain, improve mobility and function,
          or perform better in your favorite activities, our team of experienced
          therapists will be there every step of the way to support you in
          achieving your desired outcomes.
        </p>
        <Link
          to={routeNames.contact}
          className="mt-8 bg-orange inline-flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm sm:text-base md:text-lg lg:text-xl py-4 px-5 rounded-full shadow-lg transition duration-300 ease-in-out"
        >
          Book Online <FaExternalLinkAlt className="ml-2" />
        </Link>
      </div>
    </section>
  );
};

export default withAnimation(WellnessSection);
